import { FluidCache } from '@fluidframework/driver-web-cache';
import { isOdspResolvedUrl } from '@fluidx/utilities';
export async function removeSnapshotCache(resolvedUrl, partitionKey) {
    if (isOdspResolvedUrl(resolvedUrl)) {
        const cache = new FluidCache({ partitionKey, maxCacheItemAge: 0 });
        await cache.removeEntries({
            docId: resolvedUrl.hashedDocumentId,
            resolvedUrl
        });
    }
}
//# sourceMappingURL=removeSnapshotCache.js.map